export enum TRAVELERS_HIDDEN_INPUT_TYPE {
  FLIGHT_SEARCH = "FLIGHT_SEARCH",
  HOTEL_SEARCH = "HOTEL_SEARCH",
  PACKAGE_SEARCH = "PACKAGE_SEARCH",
  CRUISE_SEARCH = "CRUISE_SEARCH",
  CAR_SEARCH = "CAR_SEARCH",
  THIRD_SEARCH = "THIRD_SEARCH",
  NONE = "NONE",
}
